import { render, staticRenderFns } from "./SidebarCardDownloadFile.vue?vue&type=template&id=153dacfc"
import script from "./SidebarCardDownloadFile.vue?vue&type=script&lang=js"
export * from "./SidebarCardDownloadFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports